<template>
  <div class="torrent">
    <div style="font-size: 24px; font-weight: bold;">种子列表</div>
    <a-divider></a-divider>
    <a-descriptions style="padding-left: 8px;" :column="1">
      <template #title>
        <span>已激活站点</span><span style="color: grey; font-size: 12px;">( 需要 Vertex 客户端激活 )</span>
      </template>
      <a-descriptions-item>
        <template #label>
          <span style="margin: initial; line-height: 24px;">已激活站点</span>
        </template>
        <pre style="margin: initial; line-height: 26px; white-space: break-spaces">{{ sites.join(',') }}</pre>
        <a-button type="primary" size="small" style="margin-left: 20px;" @click="forceUpdateSites">强制刷新</a-button>
      </a-descriptions-item>
    </a-descriptions>
    <a-table
      :style="`font-size: ${isMobile() ? '12px': '14px'};`"
      :columns="columns"
      size="middle"
      :data-source="torrents"
      :pagination="{ pageSize: 20 }"
      :scroll="{ x: 2000, y: 640 }"
    >
      <template #title>
        <span style="font-size: 16px; font-weight: bold;">种子列表</span><span style="color: grey; font-size: 12px; font-weight: bold; padding-left: 12px;">累计种子: {{torrentCount}}</span>
      </template>
      <template #bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'time'">
          <pre style="margin: initial">{{ $moment(record.time * 1000).format('YYYY-MM-DD HH:mm:ss') }}</pre>
        </template>
        <template v-if="column.dataIndex === 'ip'">
          <pre style="margin: initial">{{ record.ip }}</pre>
        </template>
      </template>
    </a-table>
  </div>
</template>
<script>
export default {
  data () {
    const columns = [
      {
        title: '站点',
        dataIndex: 'site',
        width: 15,
        fixed: true
      }, {
        title: '标题',
        dataIndex: 'title',
        width: 100
      }, {
        title: '副标题',
        dataIndex: 'subtitle',
        width: 100
      }, {
        title: '时间',
        dataIndex: 'time',
        width: 72
      }
    ];
    const torrents = [];
    return {
      columns,
      sites: [],
      torrentCount: 12138,
      loading: true,
      registCode: [],
      torrents
    };
  },
  methods: {
    isMobile () {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    },
    async forceUpdateSites () {
      try {
        await this.$api().user.forceUpdateSites();
        this.getTorrents();
      } catch (e) {
        this.$message().error(e.message);
      }
    },
    async getTorrents () {
      try {
        const r = await this.$api().torrent.get();
        this.torrents = r.data.torrents;
        this.sites = r.data.sites;
        this.torrentCount = r.data.total;
        this.loading = false;
      } catch (e) {
        this.$message().error(e.message);
      }
    }
  },
  async mounted () {
    this.getTorrents();
  }
};
</script>
<style scoped>
.torrent {
  height: 100%;
  width: 100%;
}
</style>
